<div class="weights-grid" [style.grid-template-columns]="weightsGridColumns">
  <div class="header box name-column-header">
    <span class="name" i18n>Name</span>
    <div
      class="new-task-button"
      i18n-matTooltip
      matTooltip="Die Aufgabe wurde bereits an alle Teammitglieder vergeben."
      [matTooltipDisabled]="!everyoneHasObjectiveWeightTask"
    >
      <button
        i18n-matTooltip
        mat-stroked-button
        color="accent"
        (click)="assignObjectiveWeightTask()"
        [disabled]="everyoneHasObjectiveWeightTask"
      >
        <mat-icon>assignment_add</mat-icon>
        <span i18n>Zielgewichte erfragen</span>
      </button>
    </div>
  </div>
  @for (
    importanceColumn of team.importanceShares;
    track trackByIndex(columnIndex, importanceColumn);
    let first = $first;
    let columnIndex = $index
  ) {
    <div class="header box weight-column-header">
      <button mat-mini-fab color="accent" (click)="addImportanceShare(columnIndex)" class="add-column-button">
        <mat-icon>add</mat-icon>
      </button>
      @if (!first) {
        <button mat-mini-fab color="warn" (click)="removeImportanceShare(columnIndex)" class="remove-column-button">
          <mat-icon>remove</mat-icon>
        </button>
      }
      <div
        #nameDiv
        class="column-name"
        [attr.contenteditable]="!first"
        [textContent]="getImportanceColumnName(columnIndex)"
        (input)="team.importanceShareNames[columnIndex] = nameDiv.textContent; syncImportanceToServer()"
      >
      </div>
      <div> 0-100</div>
      <div class="lambda-container">
        <span i18n>Anteil:</span>
        @if (first) {
          <span>{{ team.importanceShares[0] }}</span>
        } @else {
          <input
            #lambdaInput
            dtValidateNumberInput
            [defaultValue]="0"
            type="number"
            [value]="importanceColumn"
            (input)="setImportanceShare(columnIndex, lambdaInput.valueAsNumber)"
            [min]="0"
            [max]="importanceColumn + team.importanceShares[0]"
            [integerOnly]="true"
          />
        }
        <span>%</span>
      </div>
    </div>
  }
  <div class="header box" i18n>Resultierende Gewichtung</div>
  @if (teamCalc.aggregatedProject.objectives.length > 0) {
    <div class="header box weights seperator-border" [style.grid-column]="weightsGridWeightsHeaderColumns" i18n>Zielgewichte</div>
  }
  @for (weight of teamCalc.aggregatedProject.weights.getWeightValues(); track weight; let first = $first; let index = $index) {
    <div class="header box objectives" [class.seperator-border]="first" i18n>{{ teamCalc.aggregatedProject.objectives[index].name }}</div>
  }
  @for (member of team.members; track trackByIndex(memberIndex, member); let memberIndex = $index) {
    @if (hasObjectiveWeightTask(member)) {
      <div class="box member-name">
        <dt-team-member-name [member]="member"></dt-team-member-name>
      </div>
      @for (importanceColumn of team.importanceShares; track importanceColumn; let importanceColumnIndex = $index) {
        <div class="box member-weight">
          <input
            #relevanceInput
            dtValidateNumberInput
            [defaultValue]="0"
            type="number"
            [value]="team.members[memberIndex].importance[importanceColumnIndex]"
            (input)="setMemberImportanceValue(memberIndex, importanceColumnIndex, relevanceInput.valueAsNumber)"
            [min]="0"
            [max]="100"
            [integerOnly]="true"
          />
        </div>
      }
      <div class="box"> {{ teamCalc.memberRelevance[memberIndex] / 100 | percent }}</div>
      @for (objective of teamCalc.aggregatedProject.objectives; track objective; let objectiveIndex = $index; let first = $first) {
        <div class="box weight-value" [class.seperator-border]="first">
          @if (normalizedMemberWeightValues[memberIndex][objectiveIndex] >= 0) {
            <span>{{ normalizedMemberWeightValues[memberIndex][objectiveIndex] | percent: '1.1-1' }}</span>
          } @else {
            <span>—</span>
          }
        </div>
      }
    }
  }
  <!-- Aggregat -->
  <div class="box member-name aggregat" i18n>Gewichteter Mittelwert</div>
  @for (importanceColumn of team.importanceShares; track importanceColumn; let importanceColumnIndex = $index) {
    <div class="box member-weight aggregat"> </div>
  }
  <div class="box aggregat"></div>
  @for (weight of normalizedAggregateWeightValues; track weight; let first = $first) {
    <div class="box weight-value aggregat" [class.seperator-border]="first">
      @if (weight >= 0) {
        <span>{{ weight | percent: '1.1-1' }}</span>
      } @else {
        <span>—</span>
      }
    </div>
  }
</div>
